import configData from './config'
import { fieldContactFormat } from './customFunctions'
import { include, keys, length } from './javascript'
import useTranslations from '../hooks/useTranslations'

const userValidation = ({ type, form, nonMandatoryKey }) => {
  const { t } = useTranslations()
  const { contactNumberLength } = configData
  const requiredRule = [{ required: true, message: t('error_FieldISRequire') }]
  switch (type) {
    case 'businessName':
      return requiredRule
    case 'firstName':
      return requiredRule
    case 'lastName':
      return requiredRule
    case 'name':
      return requiredRule
    case 'pincode':
      return requiredRule
    case 'country':
      return requiredRule
    case 'state':
      return requiredRule
    case 'city':
      return requiredRule
    case 'address':
      return requiredRule
    case 'emailId':
      return [
        {
          pattern: new RegExp(/[a-z0-9]+@[a-z-0-9-]+\.[a-z-0-9-]{2,3}/),
          message: t('error_InvalidEmail'),
        },
        {
          validator: (_, value) => {
            let formData = form.getFieldsValue()
            delete formData?.[_?.field]
            const emailFields = keys(formData).filter(v =>
              include(v, 'emailId'),
            )
            const emailList = emailFields.map(v => formData?.[v])
            if (value) {
              if (include(emailList, value)) {
                return Promise.reject(t('error_SameEmail'))
              }
            }
            return Promise.resolve()
          },
        },
      ]
    case 'phoneNumber':
    case 'customerPhoneNumber':
      return [
        {
          validator: (_, value) => {
            let numbers = value && value.toString().replace(/\D/g, '')
            form.setFieldValue(type, fieldContactFormat(value))
            if (
              numbers &&
              (length(numbers) < contactNumberLength ||
                length(numbers) > contactNumberLength)
            ) {
              form.setFields([
                { name: type, errors: [t('error_LengthValidation')] },
              ])
              // return Promise.reject(t('msg_LenghValidation'))
            } else {
              return Promise.resolve()
            }
          },
        },
      ]
    case 'username':
      return nonMandatoryKey
        ? [
            {
              pattern: new RegExp(/^\S*$/),
              message: t('error_SpacesNotAllowed'),
            },
          ]
        : [
            ...requiredRule,
            {
              pattern: new RegExp(/^\S*$/),
              message: t('error_SpacesNotAllowed'),
            },
          ]
    case 'password':
      return nonMandatoryKey
        ? [
            {
              validator: (_, value) => {
                if (!length(value)) return Promise.resolve()
                const replacedValue = value.replace(/\s/g, '')
                if (!length(replacedValue)) {
                  return Promise.reject(t('error_OnlySpaceNotAllowed'))
                }
                return Promise.resolve()
              },
            },
          ]
        : [
            ...requiredRule,
            {
              validator: (_, value) => {
                const replacedValue = value.replace(/\s/g, '')
                if (length(value) && !length(replacedValue)) {
                  return Promise.reject(t('error_OnlySpaceNotAllowed'))
                }
                return Promise.resolve()
              },
            },
          ]

    default:
      return [{ required: false }]
  }
}

const hasOnlySpace = str => /^\s+$/.test(str)

export { userValidation, hasOnlySpace }
